/**
 * UpgradeCta — THE SEAM where the upgrade path gets wired up.
 *
 * ── Why this renders text and not a button (read before "fixing" it) ─────────
 * There is nothing to upgrade TO yet. Checkout is Fase 2 (issues #4–#7) and the
 * pricing page is issue #9 — so a button here would be a button that goes
 * nowhere, which is worse than no button: it turns "this needs Premium" into
 * "this app is broken". Until #9 lands we therefore state the situation plainly
 * and honestly instead.
 *
 * ── What #9 has to do ───────────────────────────────────────────────────────
 * Set `UPGRADE_CTA_HREF` to the pricing route (e.g. `"/priser"`). That single
 * line turns every entitlement notice in the app — editor, invite form, all
 * three paid import buttons — into a real call to action, because they all
 * render this component via `PremiumNotice`. Nothing else needs to change; the
 * link branch below is already written and typed. (It uses react-router's
 * `Link`, so the route must exist in `App.tsx` before flipping this.)
 */

import React from "react";
import { Link } from "react-router-dom";

/**
 * Where "Se Premium" points. `null` = no destination exists yet (today).
 * ISSUE #9 SETS THIS. Keep it an app-internal route — the CTA must never be an
 * external payment link rendered straight from a server response.
 */
export const UPGRADE_CTA_HREF: string | null = null;

/** The label, once there is somewhere to go. */
export const UPGRADE_CTA_LABEL = "Se Premium";

/**
 * What we say while there is nowhere to go. Deliberately concrete about the
 * state of the world ("not yet") rather than a vague "contact us", and it never
 * suggests the user did something wrong.
 */
export const UPGRADE_CTA_PENDING_TEXT =
  "Premium kan ikke kjøpes i appen ennå – vi sier fra så snart det er klart.";

export function UpgradeCta({ testId = "upgrade-cta" }: { testId?: string }): React.JSX.Element {
  if (UPGRADE_CTA_HREF === null) {
    return (
      <p className="premium-notice-pending" data-testid={testId}>
        {UPGRADE_CTA_PENDING_TEXT}
      </p>
    );
  }

  return (
    <Link to={UPGRADE_CTA_HREF} className="btn btn-primary premium-notice-cta" data-testid={testId}>
      {UPGRADE_CTA_LABEL}
    </Link>
  );
}
